import apiClient from './apiClient';

export interface F111 {
  f111_01: string;   // 原料代號
  f111_11: string;   // 原料名稱
  f111_12: string;   // 說明
  f111_13: string;   // 研發樣品代號
  f111_21: string;   // 原料規格
  f111_22: number;   // 針孔內幅寬
  f111_221: number;  // 針孔外幅寬
  f111_23: string;   // 規格單位
  f111_24: number;   // 碼重
  f111_241: number;  // G/SQM
  f111_25: string;   // 重量單位
  f111_26: string;   // 工廠布號
  f111_27: string;   // 建檔人員
  f111_28: string | null;
  f111_29: string | null;
  f111_30: boolean;
  f111_91: string;
  f111_92: string | null;
  f111_93: string;
  fabric_numbers?: F1111[];
}

export interface F1111 {
  f1111_01: string;
  f1111_02: string;  // 公司代號
  f1111_11: string;  // 公司布號
}

const BASE = '/api/material';

const materialApi = {
  list(page = 1, size = 100, keyword = '') {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    if (keyword) params.set('keyword', keyword);
    return apiClient.get(`${BASE}?${params}`).then(r => r.data);
  },
  get(code: string): Promise<F111> {
    return apiClient.get(`${BASE}/${code}`).then(r => r.data);
  },
  create(data: Partial<F111>): Promise<F111> {
    return apiClient.post(BASE, data).then(r => r.data);
  },
  update(code: string, data: Partial<F111>): Promise<F111> {
    return apiClient.put(`${BASE}/${code}`, data).then(r => r.data);
  },
  delete(code: string): Promise<void> {
    return apiClient.delete(`${BASE}/${code}`);
  },
  copy(sourceCode: string, newCode: string): Promise<F111> {
    return apiClient.post(`${BASE}/${sourceCode}/copy`, { new_code: newCode }).then(r => r.data);
  },
};

export default materialApi;
